import React from 'react';
import { Smartphone, MessageSquare, Mail } from 'lucide-react';

const AutomationTabBar = ({ activeTab, setActiveTab }) => {
  return (
    <div style={{ 
      display: 'flex', 
      gap: '16px', 
      borderBottom: '1px solid var(--color-border-primary)',
      paddingBottom: '0'
    }}>
      <div 
        onClick={() => setActiveTab('api')}
        style={{
          padding: '12px 24px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          borderBottom: activeTab === 'api' ? '2px solid var(--color-brand-primary)' : '2px solid transparent',
          color: activeTab === 'api' ? 'var(--color-brand-primary)' : 'var(--color-text-secondary)',
          fontWeight: activeTab === 'api' ? '600' : '500',
          transition: 'all 0.2s'
        }}
      >
        <MessageSquare size={18} />
        WhatsApp API
      </div>
      <div 
        onClick={() => setActiveTab('web')}
        style={{
          padding: '12px 24px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          borderBottom: activeTab === 'web' ? '2px solid var(--color-brand-primary)' : '2px solid transparent',
          color: activeTab === 'web' ? 'var(--color-brand-primary)' : 'var(--color-text-secondary)',
          fontWeight: activeTab === 'web' ? '600' : '500',
          transition: 'all 0.2s'
        }}
      >
        <Smartphone size={18} />
        WhatsApp Web
      </div>
      <div 
        onClick={() => setActiveTab('email')}
        style={{
          padding: '12px 24px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          borderBottom: activeTab === 'email' ? '2px solid var(--color-brand-primary)' : '2px solid transparent',
          color: activeTab === 'email' ? 'var(--color-brand-primary)' : 'var(--color-text-secondary)',
          fontWeight: activeTab === 'email' ? '600' : '500',
          transition: 'all 0.2s'
        }}
      >
        <Mail size={18} />
        Email
      </div>
    </div>
  );
};

export default AutomationTabBar;
